/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobUpdateActivationRequest {
    getFixupPrototypeFunction() { return BackgroundJobUpdateActivationRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobUpdateActivationRequest>): BackgroundJobUpdateActivationRequest {
        let obj = Object.assign(new BackgroundJobUpdateActivationRequest(), model);
        BackgroundJobUpdateActivationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobUpdateActivationRequest>): BackgroundJobUpdateActivationRequest {
        if (!model) return null;
        return BackgroundJobUpdateActivationRequest.newInstance(<BackgroundJobUpdateActivationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobUpdateActivationRequest) {
        if (!obj) return;

        models.BackgroundJobUpdateActivationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobUpdateActivationRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobUpdateActivationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.next_activation === "string") {
            this.next_activation = new Date(<string><any>this.next_activation);
        }
        if (this.job) {
            models.RecordIdentity.fixupPrototype(this.job);
        }
    }

    /**
     * Background Job to update
     */
    job: models.RecordIdentity;

    /**
     * When the Background Job will execute
     */
    next_activation: Date;

}
